import { render, staticRenderFns } from "./CdssSearch.vue?vue&type=template&id=196dcbbc"
import script from "./CdssSearch.vue?vue&type=script&lang=js"
export * from "./CdssSearch.vue?vue&type=script&lang=js"
import style0 from "./CdssSearch.vue?vue&type=style&index=0&id=196dcbbc&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports